var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NavigationLayout',{attrs:{"navigationBarStyle":{
    'top': 'var(--safe-area-inset-top, 0px)',
  },"navigationContentStyle":{
    'padding-top': 'calc(44px + var(--safe-area-inset-top, 0px))',
  }}},[_c('div',{staticClass:"ly_cont",attrs:{"slot":"contents"},slot:"contents"},[_c('coin-purchase-pending'),_c('PrimaryButton',{nativeOn:{"click":function($event){return _vm.moveTo({ name: 'mypage' })}}},[_vm._v(" "+_vm._s(_vm.$t('order_details__button__back_to_coin_purchase'))+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }